import type { ValueGetterParams } from 'ag-grid-community';
import type { SteelCategory } from '../../types/common';
import type { OrganizationUserType, UserWithOrganizationType } from '../../types/user';

/**
 * ユーザが所属する組織を調べて分類一覧を返す
 * @param [ValueGetterParams]
 * @returns [SteelCategory[]] - 分類の配列
 */
const steelCategoryValueGetter = (params: ValueGetterParams): string[] => {
  const data: UserWithOrganizationType = params.data;
  const organizations: OrganizationUserType[] | undefined = data.organizations;
  // console.log(organizations);
  const steelCategories: SteelCategory[] = organizations
    ? organizations.reduce((acc, cur) => {
        const sum: SteelCategory[] = cur.steelCategory ? [...acc, ...cur.steelCategory] : [...acc];
        return sum;
      }, [])
    : [];
  const filteredSteelCategories: SteelCategory[] = Array.from(new Set(steelCategories));
  // console.log(filteredSteelCategories);
  return filteredSteelCategories;
};

export default steelCategoryValueGetter;
